/**
 * "Return to teacher's view" — SRS D6.
 *
 * A student following the teacher who then moves the board themselves stops being
 * carried along, because being dragged away mid-thought is worse than losing the
 * teacher's view. This is how they get it back, and it only exists while there is a
 * teacher's view to get back to.
 */

export interface ReturnToPresenterProps {
  readonly show: boolean;
  readonly onReturn: () => void;
}

export function ReturnToPresenter({ show, onReturn }: ReturnToPresenterProps) {
  if (!show) return null;

  return (
    <div className="absolute bottom-6 left-1/2 z-10 -translate-x-1/2">
      <button
        type="button"
        onClick={onReturn}
        className="h-touch rounded-full bg-primary px-6 text-base font-medium text-text-inverse shadow-md transition duration-fast ease-out hover:bg-primary-hover"
      >
        Return to teacher&apos;s view
      </button>
    </div>
  );
}
